import { Nilable } from "@shared/utils";
import { DTO, IDTO } from "./dto";
import { obtenerIdsTipoEstudio, obtenerNombreTipoEstudio } from "@shared/enums";

export interface ITemplateDTO extends IDTO {
    id: number;
    name: string;
    friendly_name: Nilable<string>;
}

export class TemplateDTO implements DTO {
    public id = 0;
    public nombre = "";
    public nombreAmigable: Nilable<string>;
    public nombreTipoEstudio = "";

    constructor(json: Nilable<ITemplateDTO> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: ITemplateDTO): void {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        this.nombreAmigable = json.friendly_name;
        const tipoEstudio = obtenerIdsTipoEstudio().find(tipo => tipo[1] === this.nombre);
        if (tipoEstudio) {
            const idTipoEstudio = tipoEstudio[0];
            this.nombreTipoEstudio = obtenerNombreTipoEstudio(idTipoEstudio);
        }
    }

    public toJSON(): ITemplateDTO {
        return {
            id: this.id,
            name: this.nombre,
            friendly_name: this.nombreAmigable
        };
    }

}
